import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import BgImage from "../../components/BgImage";
import { countIssues } from "../../actions/issue";
import { Doughnut } from "react-chartjs-2";

const StatisticsByMembership = ({ countIssues }) => {
  const [membersCounts, setMembersCounts] = useState([0, 0]);
  const state = {
    labels: ["Član sindikata", "Nije član sindikata"],
    datasets: [
      {
        backgroundColor: ["#00408A", "#db3e3e"],
        hoverBackgroundColor: ["#002857", "#c22424"],
        data: membersCounts,
      },
    ],
  };

  useEffect(() => {
    statsByMembers();
  }, []);

  const statsByMembers = async () => {
    let member = await countIssues({ "reporter.unionMember": true });
    let notMember = await countIssues({ "reporter.unionMember": false });
    setMembersCounts([member, notMember]);
  };
  return (
    <>
      <Header></Header>
      <BgImage></BgImage>
      <div className="container mx-auto">
        <div className="text-2xl text-center mt-10 uppercase">
          Statistika o članstvu u sindikatima
        </div>
        <Doughnut
          data={state}
          options={{
            legend: {
              display: true,
              position: "top",
            },
          }}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  countIssues,
};

export default connect(null, mapDispatchToProps)(StatisticsByMembership);
